export default "__VITE_ASSET__Ba2rpL2M__"